import { render, staticRenderFns } from "./UpsellSyncForm.vue?vue&type=template&id=4826866d"
import script from "./UpsellSyncForm.vue?vue&type=script&lang=ts"
export * from "./UpsellSyncForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports